import { createAsyncThunk } from "@reduxjs/toolkit";

import { fetchJson } from "../../../utils/ajax";
import { IBasket } from "../models";

/**
 * Loads the basket for the customer currently being assisted by this CSR agent.
 *
 * This is called when the CSR toolbar initializes to display the active basket
 * information. If a customer is being assisted, this returns their current basket.
 * The CSR can click on the basket info in the toolbar to navigate to the basket page.
 *
 * @returns Promise resolving to the currently assisted customer's basket or null
 */
export const loadCurrentlyAssistedBasket = createAsyncThunk(
    "csr/loadCurrentlyAssistedBasket",
    async (): Promise<IBasket> => {
        return fetchJson<IBasket>(
            "/api/csr/baskets/currently_assisted_basket/",
        );
    },
);
